
/*
 * VNCmail : A whole new experience in enterprise email communication.
 * Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. Look for COPYING file in the top folder.
 * If not, see http://www.gnu.org/licenses/.
 */

interface TimezoneTranslations {
  en: string;
  de: string;
}

const TIMEZONE: { [key: string]: TimezoneTranslations } = {};

TIMEZONE["Etc/GMT+12"] = {
  en: "UTC -12:00 Dateline",
  de: "UTC -12:00 Datumsgrenze"
};
TIMEZONE["Pacific/Midway"] = {
  en: "UTC -11:00 Samoa",
  de: "UTC -11:00 Samoa"
};
TIMEZONE["Etc/GMT+11"] = {
  en: "UTC -11:00 GMT-11",
  de: "UTC -11:00 UTC-11"
};
TIMEZONE["Pacific/Honolulu"] = {
  en: "UTC -10:00 Hawaii",
  de: "UTC -10:00 Hawaii"
};
TIMEZONE["America/Anchorage"] = {
  en: "UTC -09:00 Alaska",
  de: "UTC -09:00 Alaska"
};
TIMEZONE["America/Los_Angeles"] = {
  en: "UTC -08:00 US/Canada Pacific",
  de: "UTC -08:00 USA/Kanada Pazifik"
};
TIMEZONE["America/Tijuana"] = {
  en: "UTC -08:00 Baja California",
  de: "UTC -08:00 Niederkalifornien"
};
TIMEZONE["America/Denver"] = {
  en: "UTC -07:00 US/Canada Mountain",
  de: "UTC -07:00 USA/Kanada Rocky Mountains Normalzeit"
};
TIMEZONE["America/Chihuahua"] = {
  en: "UTC -07:00 Chihuahua, La Paz, Mazatlan",
  de: "UTC -07:00 Mexiko Chihuahua, La Paz, Mazatlan"
};
TIMEZONE["America/Phoenix"] = {
  en: "UTC -07:00 Arizona",
  de: "UTC -07:00 Arizona"
};
TIMEZONE["America/Chicago"] = {
  en: "UTC -06:00 US/Canada Central",
  de: "UTC -06:00 USA/Kanada Zentral"
};
TIMEZONE["America/Regina"] = {
  en: "UTC -06:00 Saskatchewan",
  de: "UTC -06:00 Saskatchewan"
};
TIMEZONE["America/Mexico_City"] = {
  en: "UTC -06:00 Guadalajara, Mexico City, Monterrey",
  de: "UTC -06:00 Guadalajara, Mexiko Stadt, Monterrey"
};
TIMEZONE["America/Guatemala"] = {
  en: "UTC -06:00 Central America",
  de: "UTC -06:00 Zentral Amerika"
};
TIMEZONE["America/New_York"] = {
  en: "UTC -05:00 US/Canada Eastern",
  de: "UTC -05:00 USA/Kanada Ostküste"
};
TIMEZONE["America/Indiana/Indianapolis"] = {
  en: "UTC -05:00 Indiana (East)",
  de: "UTC -05:00 Indiana (Ost)"
};
TIMEZONE["America/Bogota"] = {
  en: "UTC -05:00 Colombia",
  de: "UTC -05:00 Kolumbien"
};
TIMEZONE["America/Caracas"] = {
  en: "UTC -04:30 Caracas",
  de: "UTC -04:30 Caracas"
};
TIMEZONE["America/Santiago"] = {
  en: "UTC -04:00 Pacific South America",
  de: "UTC -04:00 Pazifik Südamerika"
};
TIMEZONE["America/Manaus"] = {
  en: "UTC -04:00 Manaus",
  de: "UTC -04:00 Manaus"
};
TIMEZONE["America/La_Paz"] = {
  en: "UTC -04:00 La Paz",
  de: "UTC -04:00 La Paz"
};
TIMEZONE["America/Guyana"] = {
  en: "UTC -04:00 Georgetown, La Paz, Manaus, San Juan",
  de: "UTC -04:00 Georgetown, La Paz, Manaus, San Juan"
};
TIMEZONE["America/Cuiaba"] = {
  en: "UTC -04:00 Cuiaba",
  de: "UTC -04:00 Cuiaba"
};
TIMEZONE["America/Halifax"] = {
  en: "UTC -04:00 Atlantic Time (Canada)",
  de: "UTC -04:00 Montreal, Neuschottland (Kanada)"
};
TIMEZONE["America/Asuncion"] = {
  en: "UTC -04:00 Asuncion",
  de: "UTC -04:00 Paraguayische Normalzeit"
};
TIMEZONE["America/St_Johns"] = {
  en: "UTC -03:30 Newfoundland",
  de: "UTC -03:30 Neufundland"
};
TIMEZONE["America/Montevideo"] = {
  en: "UTC -03:00 Montevideo",
  de: "UTC -03:00 Montevideo"
};
TIMEZONE["America/Godthab"] = {
  en: "UTC -03:00 Greenland",
  de: "UTC -03:00 Grönland"
};
TIMEZONE["America/Cayenne"] = {
  en: "UTC -03:00 Cayenne, Fortaleza",
  de: "UTC -03:00 Cayenne, Fortaleza"
};
TIMEZONE["America/Sao_Paulo"] = {
  en: "UTC -03:00 Brasilia",
  de: "UTC -03:00 Brasilia"
};
TIMEZONE["America/Argentina/Buenos_Aires"] = {
  en: "UTC -03:00 Argentina",
  de: "UTC -03:00 Argentinien"
};
TIMEZONE["Atlantic/South_Georgia"] = {
  en: "UTC -02:00 Mid-Atlantic",
  de: "UTC -02:00 Südgeorgien, Südliche Sandwichinseln"
};
TIMEZONE["Etc/GMT+2"] = {
  en: "UTC -02:00 GMT-02",
  de: "UTC -02:00 UTC-02"
};
TIMEZONE["Atlantic/Cape_Verde"] = {
  en: "UTC -01:00 Cape Verde Is.",
  de: "UTC -01:00 Kap Verde"
};
TIMEZONE["Atlantic/Azores"] = {
  en: "UTC -01:00 Azores",
  de: "UTC -01:00 Azoren"
};
TIMEZONE["UTC"] = {
  en: "UTC/UTC Coordinated Universal Time",
  de: "UTC Koordinierte Weltzeit"
};
TIMEZONE["Europe/London"] = {
  en: "UTC +00:00 Britain, Ireland, Portugal",
  de: "UTC +00:00 Vereinigtes Königreich, Irland, Portugal"
};
TIMEZONE["Africa/Casablanca"] = {
   en: "UTC +00:00 Casablanca",
   de: "UTC +00:00 Casablanca"
};
TIMEZONE["Africa/Casablanca"] = {
  en: "UTC +00:00 Casablanca",
  de: "UTC +00:00 Casablanca"
};
TIMEZONE["Africa/Monrovia"] = {
  en: "UTC +00:00 Monrovia",
  de: "UTC +00:00 Monrovia"
};
TIMEZONE["Europe/Berlin"] = {
  en: "UTC +01:00 Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
  de: "UTC +01:00 Amsterdam, Berlin, Bern, Rom, Stockholm, Wien"
};
TIMEZONE["Europe/Belgrade"] = {
  en: "UTC +01:00 Belgrade, Bratislava, Budapest, Ljubljana, Prague",
  de: "UTC +01:00 Belgrad, Bratislava, Budapest, Ljubljana, Prag"
};
TIMEZONE["Europe/Brussels"] = {
  en: "UTC +01:00 Brussels, Copenhagen, Madrid, Paris",
  de: "UTC +01:00 Brüssel, Kopenhagen, Madrid, Paris"
};
TIMEZONE["Africa/Windhoek"] = {
  en: "UTC +01:00 Namibia",
  de: "UTC +01:00 Namibia"
};
TIMEZONE["Europe/Warsaw"] = {
  en: "UTC +01:00 Sarajevo, Skopje, Warsaw, Zagreb",
  de: "UTC +01:00 Sarajevo, Skopje, Warschau, Zagreb"
};
TIMEZONE["Africa/Algiers"] = {
  en: "UTC +01:00 West Central Africa",
  de: "UTC +01:00 West Zentral Africa"
};
TIMEZONE["Europe/Athens"] = {
  en: "UTC +02:00 Athens, Beirut, Bucharest, Istanbul",
  de: "UTC +02:00 Athen, Bukarest, Istanbul"
};
TIMEZONE["Asia/Beirut"] = {
  en: "UTC +02:00 Beirut",
  de: "UTC +02:00 Beirut"
};
TIMEZONE["Asia/Damascus"] = {
  en: "UTC +02:00 Damascus",
  de: "UTC +02:00 Damaskus"
};
TIMEZONE["Africa/Cairo"] = {
  en: "UTC +02:00 Egypt",
  de: "UTC +02:00 Ägypten"
};
TIMEZONE["Africa/Harare"] = {
  en: "UTC +02:00 Harare, Pretoria",
  de: "UTC +02:00 Harare, Pretoria"
};
TIMEZONE["Europe/Helsinki"] = {
  en: "UTC +02:00 Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
  de: "UTC +02:00 Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius"
};
TIMEZONE["Europe/Istanbul"] = {
  en: "UTC +02:00 Istanbul",
  de: "UTC +02:00 Istanbul"
};
TIMEZONE["Asia/Jerusalem"] = {
  en: "UTC +02:00 Jerusalem",
  de: "UTC +02:00 Tel Aviv"
};
TIMEZONE["Asia/Amman"] = {
  en: "UTC +02:00 Jordan",
  de: "UTC +02:00 Jordanien"
};
TIMEZONE["Europe/Kaliningrad"] = {
  en: "UTC +02:00 Kaliningrad (RTZ 1)",
  de: "UTC +02:00 Kaliningrad (RTZ 1)"
};
TIMEZONE["Asia/Baghdad"] = {
  en: "UTC +03:00 Iraq",
  de: "UTC +03:00 Irak"
};
TIMEZONE["Asia/Kuwait"] = {
  en: "UTC +03:00 Kuwait, Riyadh",
  de: "UTC +03:00 Kuwait, Riad"
};
TIMEZONE["Europe/Minsk"] = {
  en: "UTC +03:00 Minsk",
  de: "UTC +03:00 Minsk"
};
TIMEZONE["Europe/Moscow"] = {
  en: "UTC +03:00 Moscow, St. Petersburg, Volgograd (RTZ 2)",
  de: "UTC +03:00 Moskau, Sankt Petersburg, Wolgograd"
};
TIMEZONE["Africa/Nairobi"] = {
  en: "UTC +03:00 Nairobi",
  de: "UTC +03:00 Nairobi"
};
TIMEZONE["Asia/Tehran"] = {
  en: "UTC +03:30 Tehran",
  de: "UTC +03:30 Teheran"
};
TIMEZONE["Asia/Muscat"] = {
  en: "UTC +04:00 Abu Dhabi, Muscat",
  de: "UTC +04:00 Abu Dhabi, Maskat"
};
TIMEZONE["Asia/Baku"] = {
  en: "UTC +04:00 Baku",
  de: "UTC +04:00 Baku"
};
TIMEZONE["Indian/Mauritius"] = {
  en: "UTC +04:00 Port Louis",
  de: "UTC +04:00 Port Louis"
};
TIMEZONE["Asia/Tbilisi"] = {
  en: "UTC +04:00 Tbilisi",
  de: "UTC +04:00 Tiflis"
};
TIMEZONE["Asia/Yerevan"] = {
  en: "UTC +04:00 Yerevan",
  de: "UTC +04:00 Eriwan"
};
TIMEZONE["Asia/Kabul"] = {
  en: "UTC +04:30 Kabul",
  de: "UTC +04:30 Kabul"
};
TIMEZONE["Asia/Yekaterinburg"] = {
  en: "UTC +05:00 Ekaterinburg (RTZ 4)",
  de: "UTC +05:00 Jekaterinburg (RTZ 4)"
};
TIMEZONE["Asia/Karachi"] = {
  en: "UTC +05:00 Islamabad, Karachi",
  de: "UTC +05:00 Islamabad, Karachi"
};
TIMEZONE["Asia/Tashkent"] = {
  en: "UTC +05:00 Tashkent",
  de: "UTC +5:00 Taschkent"
};
TIMEZONE["Asia/Kolkata"] = {
  en: "UTC +05:30 Chennai, Kolkata, Mumbai, New Delhi",
  de: "UTC +05:30 Chennai, Kolkata, Mumbai, Neu Delhi"
};
TIMEZONE["Asia/Colombo"] = {
  en: "UTC +05:30 Sri Jayawardenepura",
  de: "UTC +05:30 Sri Lanka"
};
TIMEZONE["Asia/Kathmandu"] = {
  en: "UTC +05:45 Kathmandu",
  de: "UTC +05:45 Kathmandu"
};
TIMEZONE["Asia/Almaty"] = {
  en: "UTC +06:00 Astana",
  de: "UTC +06:00 Astana"
};
TIMEZONE["Asia/Dhaka"] = {
  en: "UTC +06:00 Dhaka",
  de: "UTC +06:00 Dhaka"
};
TIMEZONE["Asia/Novosibirsk"] = {
  en: "UTC +06:00 Novosibirsk (RTZ 5)",
  de: "UTC +06:00 Nowosibirsk (RTZ 5)"
};
TIMEZONE["Asia/Rangoon"] = {
  en: "UTC +06:30 Rangoon",
  de: "UTC +06:30 Rangun"
};
TIMEZONE["Asia/Bangkok"] = {
  en: "UTC +07:00 Bangkok, Hanoi, Jakarta",
  de: "UTC +07:00 Bangkok, Hanoi, Jakarta"
};
TIMEZONE["Asia/Krasnoyarsk"] = {
  en: "UTC +07:00 Krasnoyarsk (RTZ 6)",
  de: "UTC +07:00 Krasnojarsk (RTZ 6)"
};
TIMEZONE["Asia/Hong_Kong"] = {
  en: "UTC +08:00 Beijing, Chongqing, Hong Kong, Urumqi",
  de: "UTC +08:00 Peking, Chongqing, Ürümqi"
};
TIMEZONE["Asia/Irkutsk"] = {
  en: "UTC +08:00 Irkutsk (RTZ 7)",
  de: "UTC +08:00 Irkutsk (RTZ 7)"
};
TIMEZONE["Asia/Kuala_Lumpur"] = {
  en: "UTC +08:00 Kuala Lumpur, Singapore",
  de: "UTC +08:00 Kuala Lumpur, Singapur"
};
TIMEZONE["Australia/Perth"] = {
  en: "UTC +08:00 Perth",
  de: "UTC +08:00 Perth"
};
TIMEZONE["Asia/Taipei"] = {
  en: "UTC +08:00 Taipei",
  de: "UTC +08:00 Taipeh"
};
TIMEZONE["Asia/Ulaanbaatar"] = {
  en: "UTC +08:00 Ulaanbaatar",
  de: "UTC +08:00 Ulaanbaatar"
};
TIMEZONE["Asia/Tokyo"] = {
  en: "UTC +09:00 Japan",
  de: "UTC +09:00 Japan"
};
TIMEZONE["Asia/Seoul"] = {
  en: "UTC +09:00 Korea",
  de: "UTC +09:00 Korea"
};
TIMEZONE["Asia/Yakutsk"] = {
  en: "UTC +09:00 Yakutsk (RTZ 8)",
  de: "UTC +09:00 Jakutsk (RTZ 8)"
};
TIMEZONE["Australia/Adelaide"] = {
  en: "UTC +09:30 Adelaide",
  de: "UTC +09:30 Adelaide"
};
TIMEZONE["Australia/Darwin"] = {
  en: "UTC +09:30 Darwin",
  de: "UTC +09:30 Darwin"
};
TIMEZONE["Australia/Brisbane"] = {
  en: "UTC +10:00 Brisbane",
  de: "UTC +10:00 Brisbane"
};
TIMEZONE["Australia/Sydney"] = {
  en: "UTC +10:00 Canberra, Melbourne, Sydney",
  de: "UTC +10:00 Canberra, Melbourne, Sydney"
};
TIMEZONE["Pacific/Guam"] = {
  en: "UTC +10:00 Guam, Port Moresby",
  de: "UTC +10:00 Guam, Port Moresby"
};
TIMEZONE["Australia/Hobart"] = {
  en: "UTC +10:00 Hobart",
  de: "UTC +10:00 Hobart"
};
TIMEZONE["Asia/Magadan"] = {
  en: "UTC +10:00 Magadan",
  de: "UTC +10:00 Magadan"
};
TIMEZONE["Asia/Vladivostok"] = {
  en: "UTC +10:00 Vladivostok, Magadan (RTZ 9)",
  de: "UTC +10:00 Wladiwostok, Magadan (RTZ 9)"
};
TIMEZONE["Pacific/Guadalcanal"] = {
  en: "UTC +11:00 Solomon Is. / New Caledonia",
  de: "UTC +11:00 Solomonen, Neukaledonien"
};
TIMEZONE["Pacific/Fiji"] = {
  en: "UTC +12:00 Fiji",
  de: "UTC +12:00 Fidschi"
};
TIMEZONE["Etc/GMT-12"] = {
  en: "UTC +12:00 GMT+12",
  de: "UTC +12:00 UTC+12"
};
TIMEZONE["Pacific/Auckland"] = {
  en: "UTC +12:00 New Zealand",
  de: "UTC +12:00 Neuseeland"
};
TIMEZONE["Asia/Kamchatka"] = {
  en: "UTC +12:00 Petropavlovsk-Kamchatsky",
  de: "UTC +12:00 Petropawlowsk-Kamtschatski"
};
TIMEZONE["Pacific/Tongatapu"] = {
  en: "UTC +13:00 Nuku'alofa",
  de: "UTC +13:00 Tonga"
};
TIMEZONE["America/Adak"] = {
  en: "UTC -10:00 Adak",
  de: "UTC -10:00 Adak (Aleuten)"
};
TIMEZONE["Pacific/Marquesas"] = {
  en: "UTC -09:30 Marquesa",
  de: "UTC -09:30 Marquesas-Inseln"
};
TIMEZONE["America/Fort_Nelson"] = {
  en: "UTC -07:00 Fort Nelson",
  de: "UTC -07:00 Fort Nelson"
};
TIMEZONE["Pacific/Easter"] = {
  en: "UTC -06:00 Easter",
  de: "UTC -06:00 Osterinsel"
};
TIMEZONE["America/Cancun"] = {
  en: "UTC -05:00 Cancun, Chetumal",
  de: "UTC -05:00 Cancun, Chetumal"
};
TIMEZONE["America/Grand_Turk"] = {
  en: "UTC -05:00 Turks and Caicos Islands",
  de: "UTC -05:00 Turks und Caicosinseln"
};
TIMEZONE["America/Havana"] = {
  en: "UTC -05:00 Havana",
  de: "UTC -05:00 Havanna"
};
TIMEZONE["America/Port-au-Prince"] = {
  en: "UTC -05:00 Port-au-Prince",
  de: "UTC -05:00 Port-au-Prince"
};
TIMEZONE["America/Araguaina"] = {
  en: "UTC -03:00 Araguaina",
  de: "UTC -03:00 Araguaina"
};
TIMEZONE["America/Bahia"] = {
  en: "UTC -03:00 Salvador",
  de: "UTC -03:00 Salvador"
};
TIMEZONE["America/Miquelon"] = {
  en: "UTC -03:00 Miquelon",
  de: "UTC -03:00 Sankt Pierre und Miquelon"
};
TIMEZONE["America/Punta_Arenas"] = {
  en: "UTC -03:00 Punta_Arena",
  de: "UTC -03:00 Punta Arenas"
};
TIMEZONE["Africa/Sao_Tome"] = {
  en: "UTC +00:00 Sao Tome",
  de: "UTC +00:00 Sao Tome"
};
TIMEZONE["Africa/Khartoum"] = {
  en: "UTC +02:00 Khartoum",
  de: "UTC +02:00 Khartum"
};
TIMEZONE["Africa/Tripoli"] = {
  en: "UTC +02:00 Tripoli",
  de: "UTC +02:00 Tripolis"
};
TIMEZONE["Asia/Gaza"] = {
  en: "UTC +02:00 Gaza",
  de: "UTC +02:00 Gaza"
};
TIMEZONE["Europe/Bucharest"] = {
  en: "UTC +02:00 Bucharest",
  de: "UTC +02:00 Bukarest"
};
TIMEZONE["Europe/Chisinau"] = {
  en: "UTC +02:00 Chisinau",
  de: "UTC +02:00 Chisinau"
};
TIMEZONE["Europe/Helsinkiu"] = {
  en: "UTC +02:00 Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
  de: "UTC +02:00 Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius"
};
TIMEZONE["Europe/Astrakhan"] = {
  en: "UTC +04:00 Astrakhan",
  de: "UTC +04:00 Astrachan"
};
TIMEZONE["Europe/Samara"] = {
  en: "UTC +04:00 Izhevsk, Samara (RTZ 3)",
  de: "UTC +04:00 Ischewsk, Samara (RTZ 3)"
};
TIMEZONE["Europe/Saratov"] = {
  en: "UTC +04:00 Saratov",
  de: "UTC +04:00 Saratow"
};
TIMEZONE["Europe/Volgograd"] = {
  en: "UTC +04:00 Volgograd",
  de: "UTC +04:00 Wolgograd"
};
TIMEZONE["Asia/Qyzylorda"] = {
  en: "UTC +05:00 Qyzylorda",
  de: "UTC +05:00 Kyzylorda"
};
TIMEZONE["Asia/Omsk"] = {
  en: "UTC +06:00 Omsk",
  de: "UTC +06:00 Omsk"
};
TIMEZONE["Asia/Yangon"] = {
  en: "UTC +06:30 Yangon",
  de: "UTC +06:30 Rangun"
};
TIMEZONE["Asia/Barnaul"] = {
  en: "UTC +07:00 Barnaul",
  de: "UTC +07:00 Barnaul"
};
TIMEZONE["Asia/Hovd"] = {
  en: "UTC +07:00 Hovd",
  de: "UTC +07:00 Chowd"
};
TIMEZONE["Asia/Tomsk"] = {
  en: "UTC +07:00 Tomsk",
  de: "UTC +07:00 Tomsk"
};
TIMEZONE["Asia/Singapor"] = {
  en: "UTC +08:00 Singapore",
  de: "UTC +08:00 Singapur"
};
TIMEZONE["Australia/Eucla"] = {
  en: "UTC +08:45 Eucla",
  de: "UTC +08:45 Eucla"
};
TIMEZONE["Asia/Chita"] = {
  en: "UTC +09:00 Chita",
  de: "UTC +09:00 Tschita"
};
TIMEZONE["Asia/Pyongyang"] = {
  en: "UTC +09:00 Pyongyang",
  de: "UTC +09:00 Pjöngjang"
};
TIMEZONE["Australia/Lord_Howe"] = {
  en: "UTC +10:30 Lord_Howe",
  de: "UTC +10:30 Lord-Howe-Insel"
};
TIMEZONE["Asia/Sakhalin"] = {
  en: "UTC +11:00 Sakhalin",
  de: "UTC +11:00 Sachalin"
};
TIMEZONE["Asia/Srednekolymsk"] = {
  en: "UTC +11:00 Chokurdakh (RTZ 10)",
  de: "UTC +11:00 Tschokurdach"
};
TIMEZONE["Pacific/Bougainville"] = {
  en: "UTC +11:00 Bougainville Standard Time",
  de: "UTC +11:00 Bougainville"
};
TIMEZONE["Pacific/Norfolk"] = {
  en: "UTC +11:00 Norfolk",
  de: "UTC +11:00 Norfolkinsel"
};
TIMEZONE["Pacific/Chatham"] = {
  en: "UTC +12:45 Chatham",
  de: "UTC +12:45 Chathaminseln"
};
TIMEZONE["Pacific/Apia"] = {
  en: "UTC +13:00 Samoa",
  de: "UTC +13:00 Samoa"
};
TIMEZONE["Pacific/Kiritimati"] = {
  en: "UTC +14:00 Kiritimati Island",
  de: "UTC +14:00 Kiritimati (Weihnachtsinsel)"
};
export default TIMEZONE;
